module.exports = __webpack_public_path__ + "static/media/icons-8-submit-document.b2c0541d.svg";